import qs from 'qs'

export const queryParticipantsPageThumbnail = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `participants-page?${query}`
}
